import { combineReducers } from 'redux';
import { authorSearch } from './authorSearch.reducer';
import { authentication } from './authentication.reducer';
import { users, dashboard, template } from './users.reducer';
import { alert } from './alert.reducer';
import { search } from './search.reducer';
import { widget } from './widget.reducer';
import { widgetSentiment } from './widgetSentiment.reducer';
import { widgetSource } from './widgetSource.reducer';
import { widgetConceptmap } from './widgetConceptmap.reducer';
import { widgetResultList } from './widgetResultList.reducer';
import { mediaLists } from './mediaList.reducer';
import { error } from './errorDisplay.reducer';
import { popKeywords } from './popKeyword.reducer';
import { channelSearch } from './channelSearch.reducer';

const rootReducer = combineReducers({
  authorSearch,
  authentication,
  users,
  dashboard,
  template,
  alert,
  widget,
  widgetSentiment,
  widgetSource,
  widgetConceptmap,
  widgetResultList,
  search,
  mediaLists,
  error,
  popKeywords,
  channelSearch,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js